export default __webpack_public_path__ + "static/media/sample_csv_file.71da9a57.csv";